var React = require('react');

function Download (props) {
    return React.createElement("svg",props,React.createElement("g",{"transform":"matrix(1,0,0,1,0.166667,0.666667)"},React.createElement("path",{"d":"M5,10.142L2.008,7.158L0.833,8.333L5.833,13.333L10.833,8.333L9.658,7.158L6.667,10.142L6.667,0L5,0L5,10.142ZM11.667,15L11.667,16.667L0,16.667L0,15L11.667,15Z","style":{"fill":"rgb(78,78,78)"}})));
}

Download.defaultProps = {"width":"100%","height":"100%","viewBox":"0 0 12 18","version":"1.1","xmlSpace":"preserve","style":{"fillRule":"evenodd","clipRule":"evenodd","strokeLinejoin":"round","strokeMiterlimit":"2"}};

module.exports = Download;

Download.default = Download;
